import { IconType, RepoTypes } from 'common-types';
import { BiGitRepoForked } from 'react-icons/bi';
import { FaGithub } from 'react-icons/fa';
import { MdInsertDriveFile as InsertDriveFileIcon } from 'react-icons/md';
import { ReactComponent as ArtifactoryStorageIcon } from './icons/artifactory-storage-icon.svg';
import { ReactComponent as AWSLogo } from './icons/aws-logo.svg';
import { ReactComponent as AzureCloudIcon } from './icons/azure-cloud-icon.svg';
import { ReactComponent as AzureIcon } from './icons/azure-repos.svg';
import { ReactComponent as BitbucketIcon } from './icons/bitBucket-icon.svg';
import { ReactComponent as GcpCloudIcon } from './icons/gcp-cloud-icon.svg';
import { ReactComponent as GcpLogo } from './icons/gcp-logo.svg';
import { ReactComponent as GitlabIcon } from './icons/gitlab-icon.svg';
import { ReactComponent as AzureTfsIcon } from './icons/azure-vs.svg';
import { ReactComponent as TfvcIcon } from './icons/tfsec.svg';

export const resolveRepoIcon = (repoType: RepoTypes, fakeApp?: boolean) => {
  if (fakeApp) {
    return BiGitRepoForked;
  }
  if (!realFakeApp(repoType)) {
    if (fakeApp) {
      return BiGitRepoForked;
    }
  }
  return repoIconsMap.get(repoType) || null;
};

const repoIconsMap = new Map<RepoTypes, IconType>([
  [RepoTypes.Azure, AzureIcon],
  [RepoTypes.AzureRepos, AzureIcon],
  [RepoTypes.AzureReposTFVC, TfvcIcon],
  [RepoTypes.AzureCloud, AzureCloudIcon],
  [RepoTypes.AzureTfs, AzureTfsIcon],
  [RepoTypes.Bitbucket, BitbucketIcon],
  [RepoTypes.BitbucketStash, BitbucketIcon],
  [RepoTypes.GitHub, FaGithub],
  [RepoTypes.GitHubSettings, FaGithub],
  [RepoTypes.GitLab, GitlabIcon],
  [RepoTypes.GitLabSmall, GitlabIcon],
  [RepoTypes.AWS, AWSLogo],
  [RepoTypes.GCP, GcpLogo],
  [RepoTypes.GcpCloud, GcpCloudIcon],
  [RepoTypes.Artifactory, InsertDriveFileIcon],
  [RepoTypes.AwsCloud, AWSLogo],
  [RepoTypes.Git, BiGitRepoForked],
  [RepoTypes.ArtifactoryStorage, ArtifactoryStorageIcon],
]);

// TODO: Move this to common-utils
const realFakeApp = (repoType: string) => {
  const checkTypes =
    repoType === RepoTypes.Artifactory ||
    repoType === RepoTypes.AWS ||
    repoType === RepoTypes.Azure ||
    repoType === RepoTypes.ArtifactoryStorage ||
    repoType === RepoTypes.GCP ||
    repoType === RepoTypes.GcpCloud ||
    repoType === RepoTypes.GitHubSettings ||
    repoType === RepoTypes.GitHub ||
    repoType === RepoTypes.AzureTfs;
  if (checkTypes) {
    return true;
  }
  return false;
};
